var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStaffManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.06733 18.0025C0.992847 18.5498 1.44772 19 2 19H15C15.5523 19 16.0072 18.5498 15.9327 18.0025C15.4397 14.3808 12.2999 11.5882 8.5 11.5882C4.70015 11.5882 1.5603 14.3808 1.06733 18.0025Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 4.70588C12.25 6.75258 10.5711 8.41177 8.5 8.41177C6.42893 8.41177 4.75 6.75258 4.75 4.70588C4.75 2.65918 6.42893 1 8.5 1C10.5711 1 12.25 2.65918 12.25 4.70588Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5.5V12.5M21 9L14 9",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStaffManagement);
export default __webpack_public_path__ + "static/media/ic_staff_management.9d9d767ddf82c0c41c4553a6f740f381.svg";
export { ForwardRef as ReactComponent };